import { useContext } from 'react';
import { createContext } from 'react';

import { TabContentItemProps } from '../@types/TabContentItemProps';

export const TabContentItemContext = createContext<TabContentItemProps>({} as TabContentItemProps);

TabContentItemContext.displayName = 'TabContentItem';

const TabContentItemProvider = (props: TabContentItemProps) => (
	<TabContentItemContext.Provider value={props}>{props.children}</TabContentItemContext.Provider>
);

export const useTabContentItem = () => {
	const context = useContext(TabContentItemContext);

	return context;
};

export default TabContentItemProvider;
